import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/insidePages';
export function InsidePreview() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const handleScroll = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const slides = Array.from(track.children) as HTMLElement[];
    const center = track.scrollLeft + track.clientWidth / 2;
    let closest = 0;
    let min = Infinity;
    slides.forEach((slide, i) => {
      const d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
      if (d < min) {
        min = d;
        closest = i;
      }
    });
    setActive(closest);
  }, []);
  useEffect(() => {
    handleScroll();
  }, [handleScroll]);
  const goTo = (i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const index = Math.max(0, Math.min(insidePages.length - 1, i));
    const slide = track.children[index] as HTMLElement;
    track.scrollTo({
      left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2,
      behavior: 'smooth'
    });
  };
  return <section className="overflow-hidden bg-white py-14 md:py-24" aria-roledescription="carrusel" aria-label="El material por dentro" data-id="element-76" data-mp="3c08fupvuf5p3">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-77" data-mp="3gx8jyv94tydk">
        <div className="flex flex-col items-center gap-5 text-center md:flex-row md:items-end md:justify-between md:text-left" data-id="element-78" data-mp="32yio1iy1u4qs">
          <div data-id="element-79" data-mp="371ezmpp690l8">
            <h2 className="font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-80" data-mp="3726t9uz7ko8v">
              El material por dentro
            </h2>
            <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-muted sm:text-lg" data-id="element-81" data-mp="2xz5t0ax0xrd4">
              Deslizá para ver algunas páginas del ebook.
            </p>
          </div>
          <div className="hidden gap-2 md:flex" data-id="element-82" data-mp="w942efm4o9mf">
            <button type="button" onClick={() => goTo(active - 1)} disabled={active === 0} aria-label="Página anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-ink transition-colors duration-150 ease-out hover:bg-parchment disabled:opacity-40 disabled:hover:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-83" data-mp="w7szei0ib5wd">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-84" data-mp="1dgv8advvrt9b" />
            </button>
            <button type="button" onClick={() => goTo(active + 1)} disabled={active === insidePages.length - 1} aria-label="Página siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-ink transition-colors duration-150 ease-out hover:bg-parchment disabled:opacity-40 disabled:hover:bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-85" data-mp="18ik0e8p5bstq">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-86" data-mp="1zr3p3ethkagd" />
            </button>
          </div>
        </div>
      </div>

      <div ref={trackRef} onScroll={handleScroll} className="mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-[12vw] pb-6 [scrollbar-width:none] sm:gap-6 md:mt-12 md:px-[max(2rem,calc((100vw-72rem)/2+2rem))] [&::-webkit-scrollbar]:hidden" data-id="element-87" data-mp="23s727tk5fsdw">
        {insidePages.map((page, i) => <figure key={page.image} className="w-[76vw] max-w-[340px] shrink-0 snap-center sm:w-[300px] md:w-[340px]" aria-label={`Página ${i + 1} de ${insidePages.length}`} data-id="element-88" data-mp="2mqrp19f0cblq" data-mpi={i}>
            <img src={page.image} alt={page.alt} loading="lazy" className="w-full rounded-xl border border-line bg-white shadow-[0_24px_50px_-24px_rgba(43,33,24,0.35)]" data-id="element-89" data-mp="2wgugh56hdhhy" />
          </figure>)}
      </div>

      <div className="mt-2 flex justify-center gap-2" role="tablist" aria-label="Elegir página" data-id="element-90" data-mp="70hur2jy9h9q">
        {insidePages.map((_, i) => <button key={i} type="button" role="tab" aria-selected={active === i} aria-label={`Ver página ${i + 1}`} onClick={() => goTo(i)} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-gold ${active === i ? 'w-6 bg-gold' : 'w-2 bg-gold-soft'}`} data-id="element-91" data-mp="20n0qq4vobkg" data-mpi={i} />)}
      </div>
    </section>;
}